import { LOGO_URL, formatWeddingDate } from "@/lib/quoteContent";

const HERO_COLLAGE =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_wedding-pricing-hub/artifacts/hs1qcup1_WVE%20DESKTOP%20BACKGROUND.jpg";

export function QuoteHero({ quote, quoteTypeLabel }) {
  const weddingDate = formatWeddingDate(quote.wedding_date);
  return (
    <section data-track-section="hero" className="relative h-screen min-h-[720px] w-full overflow-hidden">
      <img
        src={HERO_COLLAGE}
        alt=""
        className="absolute inset-0 w-full h-full object-cover blur-[4px] scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black/85" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_transparent_30%,_rgba(0,0,0,0.45)_100%)]" />

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6 fade-up">
        <img
          src={LOGO_URL}
          alt="Wedding Video Essex"
          className="h-32 md:h-40 w-auto object-contain mb-12 brightness-0 invert opacity-95"
        />
        <div className="text-white/85 font-display italic text-xl md:text-2xl tracking-wide mb-6">
          {quote.partner1_name} &amp; {quote.partner2_name}
        </div>
        <h1 className="font-display text-white text-4xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight font-medium drop-shadow-[0_4px_20px_rgba(0,0,0,0.4)] max-w-5xl">
          We are so excited to be capturing your day
          {quote.venue_name && (
            <>
              {" at "}
              <span className="italic font-light">{quote.venue_name}</span>
            </>
          )}
          {weddingDate && (
            <>
              {" on "}
              <span className="italic font-light">{weddingDate}</span>
            </>
          )}
        </h1>

        <div className="absolute bottom-12 left-1/2 -translate-x-1/2 text-white/60 text-[10px] tracking-overline uppercase font-medium flex flex-col items-center gap-2">
          <div className="w-px h-12 bg-gradient-to-b from-transparent to-white/60" />
          Scroll
        </div>
      </div>
    </section>
  );
}
